import React from 'react';
import { LoaderAnimation } from 'src/components';
import { QuantitySpinInput } from 'src/features/common';
import { DEVICE_NAMES } from '../../tech-debt/product-details-extra';
import { TertiaryButton } from 'src/common';
import { Environment } from 'src/Environment';
import './carousel-card.scss';

type CarouselCardProps = {
  title: string;
  price: string;
  hasLoaded: boolean;
  crossedOut?: string;
  image: string;
  tagText?: string;
  badge?: { color: string; text: string };
  min: number;
  max: number;
  singleSelection?: boolean;
  [key: string]: any;
};

export const CarouselCard = ({
  title = '',
  price = '',
  hasLoaded = true,
  crossedOut = '',
  image = '',
  tagText = '',
  badge = { color: 'red', text: '' },
  min,
  max,
  singleSelection = false,
  ...props
}: CarouselCardProps) => {
  const isToPComingSoon =
    title === DEVICE_NAMES.TAP_ON_PHONE &&
    Environment.current.disabledFeatures?.tapOnPhoneComingSoon;

  return (
    <section className={`carousel-card-container ${hasLoaded ? '' : 'loading'}`}>
      {hasLoaded ? (
        <>
          <header>
            <aside id="left">{tagText}</aside>
            {badge.text && (
              <aside id="right" className={badge.color}>
                {badge.text}
              </aside>
            )}
          </header>
          <img src={image} alt={title} />
          <h6>{title}</h6>
          <section>
            <p>{price}</p>
            {crossedOut && <mark>{crossedOut}</mark>}
          </section>
        </>
      ) : (
        <LoaderAnimation width="10rem" height="10rem" />
      )}
      {props['field'] && (
        <>
          {singleSelection ? (
            <TertiaryButton
              disabled={isToPComingSoon}
              type="button"
              onClick={() => props.form.setFieldValue(props.field.name, Number(!props.field.value))}
            >
              {props?.field?.value
                ? 'Remove from cart'
                : isToPComingSoon
                ? 'Coming soon!'
                : 'Add to cart'}
            </TertiaryButton>
          ) : (
            <QuantitySpinInput
              lightMode
              automationid={props?.automationId}
              disabled={!hasLoaded}
              min={min}
              max={max}
              name={props?.field?.name}
              {...props}
            />
          )}
        </>
      )}
    </section>
  );
};
